<template>
  <AppHeader :action="switchRoute">Dealer Profile</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="flex flex-col bg-white rounded-2xl shadow-sm divide-y-2 divide-slate-100">
      <div class="px-3 py-2">
        <p class="leading-none text-gray-400">Dealership ID</p>
        <p class="mt-2 text-xl leading-none">#{{ data.id }}</p>
      </div>

      <div class="px-3 py-2">
        <p class="leading-none text-gray-400">Dealership Type</p>
        <p class="mt-2 text-xl leading-none">{{ data.type }}</p>
      </div>

      <div class="px-3 py-2">
        <p class="leading-none text-gray-400">Dealership Name</p>
        <p class="mt-2 text-xl leading-none">{{ data.name }}</p>
      </div>

      <div class="px-3 py-2">
        <p class="leading-none text-gray-400">Created Date</p>
        <p class="mt-2 text-xl leading-none">{{ toDate(data.created_at) }}</p>
      </div>

      <div class="px-3 py-2">
        <p class="leading-none text-gray-400">Phone</p>
        <p class="mt-2 text-xl leading-none">{{ data.phone }}</p>
      </div>

      <div class="px-3 py-2">
        <p class="leading-none text-gray-400">Address</p>
        <p class="mt-2 text-xl leading-none">{{ data.address_1 }}, {{ data.address_2 }}, {{ data.place }}, {{ data.district }} - {{ data.pincode }}</p>
      </div>

      <div class="px-3 py-2">
        <p class="leading-none text-gray-400">Route</p>
        <p class="mt-2 text-xl leading-none">{{ data.route }}</p>
      </div>

      <div class="px-3 py-2">
        <p class="leading-none text-gray-400">PAN Number</p>
        <p class="mt-2 text-xl leading-none">{{ data.pan }}</p>
      </div>

      <div class="px-3 py-2">
        <p class="leading-none text-gray-400">Agreement Status</p>
        <p class="mt-2 text-xl leading-none">{{ data.details.agreement_status }}</p>
      </div>

      <div class="px-3 py-2">
        <p class="leading-none text-gray-400">Cheque Status</p>
        <p class="mt-2 text-xl leading-none">{{ data.details.cheque_status }}</p>
      </div>

      <div class="px-3 py-2">
        <p class="leading-none text-gray-400">Location</p>
        <p class="mt-2 text-xl leading-none"><router-link :to="{name: 'ProfileMap'}">View in Map</router-link></p>
      </div>
    </div>

    <div class="mt-10 text-center">
      <button @click="logout(true)" class="px-3 py-2 leading-none rounded-full shadow bg-slate-300">Logout</button>
    </div>

    <div class="mt-8 text-sm text-center text-gray-500">
      <p class="leading-none font-catamaran"><b>v{{ $store.state.appVersion }}</b></p>
      <p>{{ $store.state.appUpdated }}</p>
      <p class="mt-2 text-xs">App Built & Maintained by</p>
      <p><a target="_blank" href="https://simplestweb.in/?utm_campaign=UbDealerApp">SimplestWeb.in</a></p>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'Profile',
  mixins: [ mixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'loading',
      data: {},
      switchRoute: {text: null, route: null},
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'profile', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) this.data = resp.data;
        if (this.data.type == 'Company Dealership') this.switchRoute = {text: 'Switch', route: 'SwitchProfile'};
      });
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
    else this.getData();
  }
}
</script>
